import React from 'react';
import PropTypes from 'prop-types';
import './AmountOfTotal.scss';

const AmountOfTotal = (props) => {
  const { nrOfTotal, total, label } = props;
  return (
      <div className="amount-of-total-container">
        <div className="fw-bold label">{label}: &nbsp;</div> <div><span className="fw-bold"> {nrOfTotal}</span> / {total}</div>
      </div>
  );
};

export default AmountOfTotal;

AmountOfTotal.propTypes = {
  nrOfTotal: PropTypes.number,
  total: PropTypes.number,
  label: PropTypes.string,
};


